"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = exports.Content = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Content = styled_components_1.default.div `
  padding: 185px 100px;
  font-size: 16px;

  line-height: 2;

  @media (max-width: 992px) {
    padding: 145px 20px;
    font-size: 17px;
  }
`;
exports.Title = styled_components_1.default.b `
  text-decoration: underline;
  font-size: 20px;
  line-height: 3;
`;
